import React, { useRef, useState } from "react";
import { LoadScript, StandaloneSearchBox } from "@react-google-maps/api";

const libraries = ["places"];
const apiKey = "AIzaSyCkzO3JpASQCH0iEB0IpSLLOA-yai1x5FM";

function InputSearch({ handleSelectPlace, toggleHelpSection, value, setValue }) {
  const searchBoxRef = useRef(null);

  const handleLoad = (ref) => {
    searchBoxRef.current = ref;
  };

  const handlePlacesChanged = () => {
    const places = searchBoxRef.current.getPlaces();
    if (places && places.length > 0) {
      handleSelectPlace(places[0]);
    }
  };

  return (
    <div className="relative search-container">
      <div className="mt-2 py-4 text-base text-gray-600">
        Vous ne trouvez pas votre entreprise ?{" "}
        <button
          className="text-earth font-semibold underline hover:text-lavender"
          onClick={toggleHelpSection}
        >
          Essayez ceci
        </button>
      </div>
      <LoadScript googleMapsApiKey={apiKey} libraries={libraries}>
        <StandaloneSearchBox onLoad={handleLoad} onPlacesChanged={handlePlacesChanged}>
          <input
            type="text"
            id="searchInput"
            className="w-full sm:w-3/4 md:w-1/2 lg:w-1/3 px-4 py-2 border-2 border border-gray-200 rounded-md shadow-almost-shadow hover:border-night hover:border-2 focus:outline-none focus:border-night"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="Commencez à taper le nom et l'adresse de votre entreprise..."
            required
          />
        </StandaloneSearchBox>
      </LoadScript>
    </div>
  );
}

export default InputSearch;
